import React from "react";
import styled from "@emotion/styled";

const P = styled.p`
  font-weight: normal;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  color: #30251D;
`;
const Title = styled.h1`
  font-weight: bold;
  font-size: 64px;
  line-height: 95px;
  text-align: center;
  color: #30251D;
  @media screen and (max-width: 767px) {
    font-size: 42px;
    line-height: 80px;
  }
`;

const CaseTitle = (props) => {
  const {num, text} = props.title;
  return (
    <div>
      <P>CASE {num}</P>
      <Title>{text}</Title>
    </div>
  )
};

export default CaseTitle;